import React, { useCallback, useMemo } from 'react';
import { FlashList } from '@shopify/flash-list';
import { FlatList, View } from 'react-native';
import { rem } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import { useSortBySelector } from 'design-system/SortBySelector/useSortBySelector';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { selectFilteredMerchants } from 'reducers/selectors';
import EmptyComponent from './KeyboardEmpty';
import { isDesktopOrWeb, isWeb } from '../../../../constants';
import KeyboardMerchantsRow from './KeyboardMerchantsRow';
const strings = {
    empty: 'There are no merchants available in any of your transactions',
};
const keyExtractor = (item) => item.id.toString();
const KeyboardMerchants = ({ onSelect, activeFilters, settingsFilter, contentContainerStyle }) => {
    const { sortMethod, Button } = useSortBySelector('Merchant');
    const data = useAppSelector((state) => selectFilteredMerchants(state, sortMethod));
    const activeFilterMap = useMemo(() => activeFilters?.reduce((acc, curr) => {
        acc[curr.id] = true;
        return acc;
    }, {}), [activeFilters]);
    const type = useMemo(() => (settingsFilter === 'AND' ? 'single' : 'multiple'), [settingsFilter]);
    const renderItem = useCallback(({ item }) => (<KeyboardMerchantsRow item={item} type={type} isSelected={activeFilterMap?.[item.id]} onPress={() => {
            onSelect('KeyboardMerchants', {
                ...item,
                badgeText: item.displayName,
                filterType: 'MERCHANT',
            });
        }}/>), [activeFilterMap, onSelect, type]);
    const styles = useStyles(styleSet);
    const flatListStyles = useMarginBottom('paddingBottom', undefined, contentContainerStyle);
    const Content = useMemo(() => {
        const baseProps = {
            data,
            renderItem,
            keyExtractor,
            style: styles.flatList,
            contentContainerStyle: flatListStyles,
            ListEmptyComponent: <EmptyComponent description={strings.empty}/>,
        };
        if (isWeb) {
            return <FlatList {...baseProps}/>;
        }
        return <FlashList {...baseProps} extraData={[activeFilterMap, onSelect]}/>;
    }, [activeFilterMap, data, flatListStyles, onSelect, renderItem, styles.flatList]);
    return (<>
      <View style={contentContainerStyle}>
        <SectionHeader horizontalMargins style={styles.sectionHeader} button={Button}>
          Merchants
        </SectionHeader>
      </View>
      {Content}
    </>);
};
const styleSet = createStyleSheets(() => ({
    flatList: {
        ...(isDesktopOrWeb && {
            padding: 8,
        }),
    },
    sectionHeader: {
        paddingTop: rem(12),
    },
}));
export default KeyboardMerchants;
